import type { UserAiMessage, UserAiMessageAction } from '@entities/user';
import type { OutgoingChatMessage } from '@packages/chat/react';
import type { ChatSide } from '@packages/chat/ui';
import {
  getAdminSenderDisplayName,
  getUserAiMessageDisplay,
} from './getUserAiMessageDisplay';

const VOICE_MESSAGE_NAME = 'Голосовое сообщение';

/** A message of the conversation, confirmed by the server or still local. */
export type UserSintiaChatItem = {
  key: string;
  time: string;
  message: string | null;
  fileName: string;
  audioUrl: string;
  contentType: string;
  sender: ChatSide;
  senderName: string;
  isAi: boolean;
  status?: string;
  transcription?: string | null;
  actions?: UserAiMessageAction | null;
};

export const toServerChatItem = (
  message: UserAiMessage,
  employerDisplayName: string
): UserSintiaChatItem => ({
  key: `server:${message.id}`,
  time: message.createdAt,
  message: message.content,
  fileName: message.file?.name ?? VOICE_MESSAGE_NAME,
  audioUrl: message.file?.absolutePath ?? '',
  contentType: message.contentType,
  status: message.status,
  transcription: message.transcription,
  actions: message.actions,
  ...getUserAiMessageDisplay(message, employerDisplayName),
});

/** The administrator's sent message, shown with a loader until it returns. */
export const toLocalChatItem = (
  message: OutgoingChatMessage,
  sender: UserAiMessage['sender']
): UserSintiaChatItem => ({
  key: `local:${message.clientId}`,
  time: message.createdAt,
  message: message.text,
  fileName: message.audio?.name ?? VOICE_MESSAGE_NAME,
  audioUrl: message.audio?.url ?? '',
  contentType: message.audio ? 'Audio' : 'Text',
  status: 'Pending',
  transcription: null,
  sender: 'other',
  senderName: getAdminSenderDisplayName(sender),
  isAi: false,
});
